import { isNaN, isNil } from "lodash";

export function formatCurrency(value, currency, showZeroIfNan = false) {
    if (isNil(value) || isNaN(value)) {
        if (showZeroIfNan) return `0 ${currency || "€"}`;
        return "";
    }

    if (!currency) {
        return value / 100;
    }

    return (
        (value / 100).toLocaleString("en-GB", {
            style: 'currency',
            currency: currency,
        })
    );
}
